/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';

import './listItem.css';

const ns = 'list-item';

export type ListItemType = {
  data: {
    idNumber: number;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    email: string;
    status: string;
  };
};

export default ({
  data: { idNumber, firstName, email, lastName, mobileNumber, status },
}: ListItemType) => (
  <div className={ns}>
    <div className="customer-firstName ">
      <p className="three-dots">
        {firstName || lastName
          ? `${firstName} ${lastName}`
          : '-- Not registered --'}
      </p>
    </div>
    <div className="customer-email">
      <p>{email}</p>
    </div>
    <div className="customer-mobileNumber">
      <p>{mobileNumber}</p>
    </div>
    <div className="customer-id">
      <p>{idNumber}</p>
    </div>
    <div className="customer-status">
      <span className={`status-badge status-badge--${(status || '').toLowerCase()}`}>
        {status || '—'}
      </span>
    </div>
  </div>
);
